/**
 * Root reducer
 */

import { combineReducers } from 'redux';
import categoryData, { CategoryReducer } from 'store/reducers/category.reducer';
import { CmsReducer, cmsReducer as cms } from 'store/reducers/cms.reducer';
import commonData, { CommonDataReducer } from 'store/reducers/common.reducer';
import filterMenu, { FilterMenuReducer } from 'store/reducers/filter-menu.reducer';
import globalLoaderData, { GlobalLoaderReducer } from 'store/reducers/global-loader.reducer';
import historyData, { HistoryReducer } from 'store/reducers/history.reducer';
import homePageData, { HomePageReducer } from 'store/reducers/home-page.reducer';
import loginData, { LoginReducer } from 'store/reducers/login.reducer';
import memoizeData, { Memoize } from 'store/reducers/memoize.reducer';
import messagesCountData, { MessagesReducer } from 'store/reducers/messages.reducer';
import myShopPageData, { MyShopPageReducer } from 'store/reducers/my-shop-page.reducer';
import productsPageData, { ProductsPageReducer } from 'store/reducers/products-page.reducer';
import searchSession, { SearchSessionReducer } from 'store/reducers/searchSession.reducer';
import shipping, { ShippingReducer } from 'store/reducers/shipping.reducer';
import shopFollowData, { ShopFollowReducer } from 'store/reducers/shop-follow.reducer';
import shopsPageData, { ShopsPageReducer } from 'store/reducers/shops-page.reducer';
import sideMenuData, { SideMenuReducer } from 'store/reducers/sidemenu.reducer';
import userData, { UserReducer } from 'store/reducers/user.reducer';
import userSavedSearchData, { UserSavedSearchReducer } from 'store/reducers/user-saved-searches.reducer';

export type StoreData = {
  userData: UserReducer;
  homePageData: HomePageReducer;
  shopsPageData: ShopsPageReducer;
  shopFollowData: ShopFollowReducer;
  productsPageData: ProductsPageReducer;
  sideMenuData: SideMenuReducer;
  loginData: LoginReducer;
  memoizeData: Memoize;
  myShopPageData: MyShopPageReducer;
  messagesCountData: MessagesReducer;
  historyData: HistoryReducer;
  globalLoaderData: GlobalLoaderReducer;
  commonData: CommonDataReducer;
  cms: CmsReducer;
  categoryData: CategoryReducer;
  filterMenu: FilterMenuReducer;
  userSavedSearchData: UserSavedSearchReducer;
  shipping: ShippingReducer;
  searchSession: SearchSessionReducer;
};

export default combineReducers({
  userData,
  homePageData,
  shopsPageData,
  shopFollowData,
  productsPageData,
  sideMenuData,
  loginData,
  memoizeData,
  myShopPageData,
  messagesCountData,
  historyData,
  globalLoaderData,
  commonData,
  cms,
  categoryData,
  filterMenu,
  userSavedSearchData,
  shipping,
  searchSession,
});
